"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f109 = void 0;
exports.f109 = {
    "maa": [
        "Latn"
    ],
    "mab": [
        "Latn"
    ],
    "mad": [
        "Latn"
    ],
    "mae": [
        "Latn"
    ],
    "maf": [
        "Latn"
    ],
    "mag": [
        "Deva"
    ],
    "mai": [
        "Deva",
        "Kthi",
        "Newa",
        "Tirh"
    ],
    "maj": [
        "Latn"
    ],
    "mak": [
        "Latn",
        "Bugi",
        "Maka"
    ],
    "mam": [
        "Latn"
    ],
    "man": [
        "Latn",
        "Arab",
        "Nkoo"
    ],
    "maq": [
        "Latn"
    ],
    "mas": [
        "Latn"
    ],
    "mat": [
        "Latn"
    ],
    "mau": [
        "Latn"
    ],
    "mav": [
        "Latn"
    ],
    "maw": [
        "Latn",
        "Arab"
    ],
    "max": [
        "Latn"
    ],
    "maz": [
        "Latn"
    ],
    "mba": [
        "Latn"
    ],
    "mbb": [
        "Latn"
    ],
    "mbc": [
        "Latn"
    ],
    "mbd": [
        "Latn"
    ],
    "mbe": [
        "Zyyy"
    ],
    "mbf": [
        "Latn"
    ],
    "mbh": [
        "Latn"
    ],
    "mbi": [
        "Latn"
    ],
    "mbj": [
        "Latn"
    ],
    "mbk": [
        "Latn"
    ],
    "mbl": [
        "Latn"
    ],
    "mbm": [
        "Latn"
    ],
    "mbn": [
        "Latn"
    ],
    "mbo": [
        "Latn"
    ],
    "mbp": [
        "Latn"
    ],
    "mbq": [
        "Latn"
    ],
    "mbr": [
        "Latn"
    ],
    "mbs": [
        "Latn"
    ],
    "mbt": [
        "Latn"
    ],
    "mbu": [
        "Latn"
    ],
    "mbv": [
        "Latn"
    ],
    "mbw": [
        "Latn"
    ],
    "mbx": [
        "Latn"
    ],
    "mby": [
        "Arab"
    ],
    "mbz": [
        "Latn"
    ],
    "mca": [
        "Latn"
    ],
    "mcb": [
        "Latn"
    ],
    "mcc": [
        "Latn"
    ],
    "mcd": [
        "Latn"
    ],
    "mce": [
        "Latn"
    ],
    "mcf": [
        "Latn"
    ],
    "mcg": [
        "Latn"
    ],
    "mch": [
        "Latn"
    ],
    "mci": [
        "Latn"
    ],
    "mcj": [
        "Latn"
    ],
    "mck": [
        "Latn"
    ],
    "mcl": [
        "Latn"
    ],
    "mcm": [
        "Latn"
    ],
    "mcn": [
        "Latn"
    ],
    "mco": [
        "Latn"
    ],
    "mcp": [
        "Latn"
    ],
    "mcq": [
        "Latn"
    ],
    "mcr": [
        "Latn"
    ],
    "mcs": [
        "Latn"
    ],
    "mct": [
        "Latn"
    ],
    "mcu": [
        "Latn"
    ],
    "mcv": [
        "Latn"
    ],
    "mcw": [
        "Latn"
    ],
    "mcx": [
        "Latn"
    ],
    "mcy": [
        "Latn"
    ],
    "mcz": [
        "Latn"
    ],
    "mda": [
        "Latn"
    ],
    "mdb": [
        "Latn"
    ],
    "mdc": [
        "Latn"
    ],
    "mdd": [
        "Latn"
    ],
    "mde": [
        "Arab",
        "Latn"
    ],
    "mdf": [
        "Cyrl"
    ],
    "mdg": [
        "Latn"
    ],
    "mdh": [
        "Latn"
    ],
    "mdi": [
        "Latn"
    ],
    "mdj": [
        "Latn"
    ],
    "mdk": [
        "Latn"
    ],
    "mdl": [
        "Zxxx"
    ],
    "mdm": [
        "Latn"
    ],
    "mdn": [
        "Latn"
    ],
    "mdp": [
        "Latn"
    ],
    "mdq": [
        "Latn"
    ],
    "mdr": [
        "Latn",
        "Bugi"
    ],
    "mds": [
        "Latn"
    ],
    "mdt": [
        "Latn"
    ],
    "mdu": [
        "Latn"
    ],
    "mdv": [
        "Latn"
    ],
    "mdw": [
        "Latn"
    ],
    "mdx": [
        "Ethi",
        "Latn"
    ],
    "mdy": [
        "Ethi",
        "Latn"
    ],
    "mdz": [
        "Latn"
    ],
    "mea": [
        "Latn"
    ],
    "meb": [
        "Latn"
    ],
    "mec": [
        "Latn"
    ],
    "med": [
        "Latn"
    ],
    "mee": [
        "Latn"
    ],
    "mef": [
        "Zyyy"
    ],
    "meh": [
        "Latn"
    ],
    "mei": [
        "Zyyy"
    ],
    "mej": [
        "Latn"
    ],
    "mek": [
        "Latn"
    ],
    "mel": [
        "Latn"
    ],
    "mem": [
        "Latn"
    ],
    "men": [
        "Latn",
        "Mend"
    ],
    "meo": [
        "Latn",
        "Arab"
    ],
    "mep": [
        "Latn"
    ],
    "meq": [
        "Latn"
    ],
    "mer": [
        "Latn"
    ],
    "mes": [
        "Latn"
    ],
    "met": [
        "Latn"
    ],
    "meu": [
        "Latn"
    ],
    "mev": [
        "Latn"
    ],
    "mew": [
        "Latn"
    ],
    "mey": [
        "Latn",
        "Arab"
    ],
    "mez": [
        "Latn"
    ],
    "mfa": [
        "Arab",
        "Thai"
    ],
    "mfb": [
        "Latn"
    ],
    "mfc": [
        "Latn"
    ],
    "mfd": [
        "Latn"
    ],
    "mfe": [
        "Latn"
    ],
    "mff": [
        "Latn"
    ],
    "mfg": [
        "Latn",
        "Arab"
    ],
    "mfh": [
        "Latn"
    ],
    "mfi": [
        "Arab",
        "Latn"
    ],
    "mfj": [
        "Latn"
    ],
    "mfk": [
        "Latn"
    ],
    "mfl": [
        "Latn"
    ],
    "mfm": [
        "Latn"
    ],
    "mfn": [
        "Latn"
    ],
    "mfo": [
        "Latn"
    ],
    "mfp": [
        "Latn"
    ],
    "mfq": [
        "Latn"
    ],
    "mfr": [
        "Latn"
    ],
    "mfs": [
        "Zxxx"
    ],
    "mft": [
        "Latn"
    ],
    "mfu": [
        "Latn"
    ],
    "mfv": [
        "Latn"
    ],
    "mfw": [
        "Latn"
    ],
    "mfx": [
        "Zyyy"
    ],
    "mfy": [
        "Latn"
    ],
    "mfz": [
        "Latn"
    ],
    "mg": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "mga": [
        "Latg"
    ],
    "mgb": [
        "Latn"
    ],
    "mgc": [
        "Latn"
    ],
    "mgd": [
        "Latn",
        "Arab"
    ],
    "mge": [
        "Latn"
    ],
    "mgf": [
        "Latn"
    ],
    "mgg": [
        "Latn"
    ],
    "mgh": [
        "Latn"
    ],
    "mgi": [
        "Latn"
    ],
    "mgj": [
        "Latn"
    ],
    "mgk": [
        "Latn"
    ],
    "mgl": [
        "Latn"
    ],
    "mgm": [
        "Latn"
    ],
    "mgn": [
        "Latn"
    ],
    "mgo": [
        "Latn"
    ],
    "mgp": [
        "Deva",
        "Brah"
    ],
    "mgq": [
        "Latn"
    ],
    "mgr": [
        "Latn"
    ],
    "mgs": [
        "Latn"
    ],
    "mgt": [
        "Latn"
    ],
    "mgu": [
        "Latn"
    ],
    "mgv": [
        "Latn"
    ],
    "mgw": [
        "Latn"
    ],
    "mgy": [
        "Latn"
    ],
    "mgz": [
        "Latn"
    ],
    "mh": [
        "Latn"
    ],
    "mha": [
        "Zyyy"
    ],
    "mhb": [
        "Latn"
    ],
    "mhc": [
        "Latn"
    ],
    "mhd": [
        "Latn"
    ],
    "mhe": [
        "Latn"
    ],
    "mhf": [
        "Latn"
    ],
    "mhg": [
        "Latn"
    ],
    "mhi": [
        "Latn"
    ],
    "mhj": [
        "Arab"
    ],
    "mhk": [
        "Latn"
    ],
    "mhl": [
        "Latn"
    ],
    "mhm": [
        "Latn"
    ],
    "mhn": [
        "Latn"
    ],
    "mho": [
        "Latn"
    ],
    "mhp": [
        "Latn"
    ],
    "mhq": [
        "Latn"
    ],
    "mhs": [
        "Latn"
    ],
    "mht": [
        "Latn"
    ],
    "mhu": [
        "Latn"
    ],
    "mhw": [
        "Latn"
    ],
    "mhx": [
        "Latn"
    ],
    "mhy": [
        "Latn"
    ],
    "mhz": [
        "Latn"
    ],
    "mi": [
        "Latn"
    ],
    "mia": [
        "Latn"
    ],
    "mib": [
        "Latn"
    ],
    "mic": [
        "Latn",
        "Zzzz"
    ],
    "mid": [
        "Mand"
    ],
    "mie": [
        "Latn"
    ],
    "mif": [
        "Latn"
    ],
    "mig": [
        "Latn"
    ],
    "mih": [
        "Latn"
    ],
    "mii": [
        "Latn"
    ],
    "mij": [
        "Latn"
    ],
    "mik": [
        "Latn"
    ],
    "mil": [
        "Latn"
    ],
    "mim": [
        "Latn"
    ],
    "min": [
        "Latn",
        "Arab"
    ],
    "mio": [
        "Latn"
    ],
    "mip": [
        "Latn"
    ],
    "miq": [
        "Latn"
    ],
    "mir": [
        "Latn"
    ],
    "mis": [
        "Hatr"
    ],
    "mit": [
        "Latn"
    ],
    "miu": [
        "Latn"
    ],
    "miw": [
        "Latn"
    ],
    "mix": [
        "Latn"
    ],
    "miy": [
        "Latn"
    ],
    "miz": [
        "Latn"
    ],
    "mjb": [
        "Latn"
    ],
    "mjc": [
        "Latn"
    ],
    "mjd": [
        "Latn"
    ],
    "mje": [
        "Latn"
    ],
    "mjg": [
        "Latn"
    ],
    "mjh": [
        "Latn"
    ],
    "mji": [
        "Latn"
    ],
    "mjj": [
        "Latn"
    ],
    "mjk": [
        "Latn"
    ],
    "mjl": [
        "Deva",
        "Takr"
    ],
    "mjm": [
        "Latn"
    ],
    "mjn": [
        "Latn"
    ],
    "mjo": [
        "Zyyy"
    ],
    "mjp": [
        "Zyyy"
    ],
    "mjq": [
        "Zyyy"
    ],
    "mjr": [
        "Zyyy"
    ],
    "mjs": [
        "Latn"
    ],
    "mjt": [
        "Deva",
        "Beng"
    ],
    "mju": [
        "Telu"
    ],
    "mjv": [
        "Mlym"
    ],
    "mjw": [
        "Latn"
    ],
    "mjx": [
        "Latn",
        "Beng"
    ],
    "mjy": [
        "Zyyy"
    ],
    "mjz": [
        "Deva"
    ],
    "mk": [
        "Cyrl",
        "Brai"
    ],
    "mka": [
        "Latn"
    ],
    "mkb": [
        "Deva"
    ],
    "mkc": [
        "Latn"
    ],
    "mke": [
        "Deva"
    ],
    "mkf": [
        "Latn"
    ],
    "mkg": [
        "Zyyy"
    ],
    "mki": [
        "Arab",
        "Deva"
    ],
    "mkj": [
        "Latn"
    ],
    "mkk": [
        "Latn"
    ],
    "mkl": [
        "Latn"
    ],
    "mkm": [
        "Thai"
    ],
    "mkn": [
        "Latn"
    ],
    "mko": [
        "Latn"
    ],
    "mkp": [
        "Latn"
    ],
    "mkq": [
        "Zyyy"
    ],
    "mkr": [
        "Latn"
    ],
    "mks": [
        "Latn"
    ],
    "mkt": [
        "Latn"
    ],
    "mku": [
        "Latn"
    ],
    "mkv": [
        "Latn"
    ],
    "mkw": [
        "Latn"
    ],
    "mkx": [
        "Latn"
    ],
    "mky": [
        "Latn"
    ],
    "mkz": [
        "Latn"
    ],
    "ml": [
        "Mlym",
        "Arab",
        "Brai"
    ],
    "mla": [
        "Latn"
    ],
    "mlb": [
        "Latn"
    ],
    "mlc": [
        "Latn"
    ],
    "mle": [
        "Latn"
    ],
    "mlf": [
        "Thai",
        "Latn"
    ],
    "mlh": [
        "Latn"
    ],
    "mli": [
        "Latn"
    ],
    "mlj": [
        "Latn"
    ],
    "mlk": [
        "Latn"
    ],
    "mll": [
        "Latn"
    ],
    "mlm": [
        "Zyyy"
    ],
    "mln": [
        "Latn"
    ],
    "mlo": [
        "Latn"
    ],
    "mlp": [
        "Latn"
    ],
    "mlq": [
        "Arab",
        "Latn"
    ],
    "mlr": [
        "Latn"
    ],
    "mls": [
        "Latn"
    ],
    "mlu": [
        "Latn"
    ],
    "mlv": [
        "Latn"
    ],
    "mlw": [
        "Latn"
    ],
    "mlx": [
        "Latn"
    ],
    "mlz": [
        "Latn"
    ],
    "mma": [
        "Latn"
    ],
    "mmb": [
        "Latn"
    ],
    "mmc": [
        "Latn"
    ],
    "mmd": [
        "Latn",
        "Hans",
        "Hant"
    ],
    "mme": [
        "Latn"
    ],
    "mmf": [
        "Latn"
    ],
    "mmg": [
        "Latn"
    ],
    "mmh": [
        "Latn"
    ],
    "mmi": [
        "Latn"
    ],
    "mmj": [
        "Zyyy"
    ],
    "mmk": [
        "Zyyy"
    ],
    "mml": [
        "Zyyy"
    ],
    "mmm": [
        "Latn"
    ],
    "mmn": [
        "Latn"
    ],
    "mmo": [
        "Latn"
    ],
    "mmp": [
        "Latn"
    ],
    "mmq": [
        "Latn"
    ],
    "mmr": [
        "Latn"
    ],
    "mmt": [
        "Latn"
    ],
    "mmu": [
        "Latn"
    ],
    "mmv": [
        "Latn"
    ],
    "mmw": [
        "Latn"
    ],
    "mmx": [
        "Latn"
    ],
    "mmy": [
        "Latn"
    ],
    "mmz": [
        "Latn"
    ],
    "mn": [
        "Cyrl",
        "Brai",
        "Mong",
        "Phag",
        "Tibt"
    ],
    "mna": [
        "Latn"
    ],
    "mnb": [
        "Latn"
    ],
    "mnc": [
        "Mong"
    ],
    "mnd": [
        "Latn"
    ],
    "mne": [
        "Latn"
    ],
    "mnf": [
        "Latn"
    ],
    "mng": [
        "Latn"
    ],
    "mnh": [
        "Latn"
    ],
    "mni": [
        "Beng",
        "Brai",
        "Mtei"
    ],
    "mnj": [
        "Arab"
    ],
    "mnl": [
        "Latn"
    ],
    "mnm": [
        "Latn"
    ],
    "mnn": [
        "Latn"
    ],
    "mnp": [
        "Latn"
    ],
    "mnq": [
        "Latn"
    ],
    "mnr": [
        "Latn"
    ],
    "mns": [
        "Cyrl"
    ],
    "mnu": [
        "Latn"
    ],
    "mnv": [
        "Latn"
    ],
    "mnw": [
        "Mymr"
    ],
    "mnx": [
        "Latn"
    ],
    "mny": [
        "Latn"
    ],
    "mnz": [
        "Latn"
    ],
    "moa": [
        "Latn"
    ],
    "moc": [
        "Latn"
    ],
    "mod": [
        "Zyyy"
    ],
    "moe": [
        "Latn"
    ],
    "mog": [
        "Latn"
    ],
    "moh": [
        "Latn"
    ],
    "moi": [
        "Latn"
    ],
    "moj": [
        "Latn"
    ],
    "mok": [
        "Latn"
    ],
    "mom": [
        "Latn"
    ],
    "moo": [
        "Latn"
    ],
    "mop": [
        "Latn"
    ],
    "moq": [
        "Latn"
    ],
    "mor": [
        "Latn"
    ],
    "mos": [
        "Latn",
        "Brai"
    ],
    "mot": [
        "Latn"
    ],
    "mou": [
        "Latn"
    ],
    "mov": [
        "Latn"
    ],
    "mow": [
        "Latn"
    ],
    "mox": [
        "Latn"
    ],
    "moy": [
        "Latn",
        "Ethi"
    ],
    "moz": [
        "Latn"
    ],
    "mpa": [
        "Latn"
    ],
    "mpb": [
        "Latn"
    ],
    "mpc": [
        "Latn"
    ],
    "mpd": [
        "Latn"
    ],
    "mpe": [
        "Latn",
        "Ethi"
    ],
    "mpg": [
        "Latn"
    ],
    "mph": [
        "Latn"
    ],
    "mpi": [
        "Latn"
    ],
    "mpj": [
        "Latn"
    ],
    "mpk": [
        "Latn"
    ],
    "mpl": [
        "Latn"
    ],
    "mpm": [
        "Latn"
    ],
    "mpn": [
        "Latn"
    ],
    "mpo": [
        "Latn"
    ],
    "mpp": [
        "Latn"
    ],
    "mpq": [
        "Latn"
    ],
    "mpr": [
        "Latn"
    ],
    "mps": [
        "Latn"
    ],
    "mpt": [
        "Latn"
    ],
    "mpu": [
        "Latn"
    ],
    "mpv": [
        "Latn"
    ],
    "mpw": [
        "Latn"
    ],
    "mpx": [
        "Latn"
    ],
    "mpy": [
        "Latn"
    ],
    "mpz": [
        "Thai"
    ],
    "mqa": [
        "Latn"
    ],
    "mqb": [
        "Latn"
    ],
    "mqc": [
        "Latn"
    ],
    "mqe": [
        "Latn"
    ],
    "mqf": [
        "Latn"
    ],
    "mqg": [
        "Latn"
    ],
    "mqh": [
        "Latn"
    ],
    "mqi": [
        "Latn"
    ],
    "mqj": [
        "Latn"
    ],
    "mqk": [
        "Latn"
    ],
    "mql": [
        "Latn"
    ],
    "mqm": [
        "Latn"
    ],
    "mqn": [
        "Latn"
    ],
    "mqo": [
        "Latn"
    ],
    "mqp": [
        "Latn"
    ],
    "mqq": [
        "Latn"
    ],
    "mqr": [
        "Latn"
    ],
    "mqs": [
        "Latn"
    ],
    "mqt": [
        "Zyyy"
    ],
    "mqu": [
        "Latn"
    ],
    "mqv": [
        "Latn"
    ],
    "mqw": [
        "Latn"
    ],
    "mqx": [
        "Latn",
        "Bugi"
    ],
    "mqy": [
        "Latn"
    ],
    "mqz": [
        "Latn"
    ],
    "mr": [
        "Deva",
        "Brai",
        "Modi"
    ],
    "mra": [
        "Thai"
    ],
    "mrb": [
        "Latn"
    ],
    "mrc": [
        "Latn"
    ],
    "mrd": [
        "Deva"
    ],
    "mre": [
        "Zxxx"
    ],
    "mrf": [
        "Latn"
    ],
    "mrg": [
        "Latn",
        "Beng",
        "Deva"
    ],
    "mrh": [
        "Latn"
    ],
    "mrj": [
        "Cyrl"
    ],
    "mrk": [
        "Latn"
    ],
    "mrl": [
        "Latn"
    ],
    "mrm": [
        "Latn"
    ],
    "mrn": [
        "Latn"
    ],
    "mro": [
        "Mroo",
        "Latn"
    ],
    "mrp": [
        "Latn"
    ],
    "mrq": [
        "Latn"
    ],
    "mrr": [
        "Deva"
    ],
    "mrs": [
        "Latn"
    ],
    "mrt": [
        "Latn"
    ],
    "mru": [
        "Latn"
    ],
    "mrv": [
        "Latn"
    ],
    "mrw": [
        "Latn"
    ],
    "mrx": [
        "Latn"
    ],
    "mry": [
        "Latn"
    ],
    "mrz": [
        "Latn"
    ],
    "ms": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "msb": [
        "Latn"
    ],
    "msc": [
        "Latn"
    ],
    "msd": [
        "Zxxx"
    ],
    "mse": [
        "Latn"
    ],
    "msf": [
        "Latn"
    ],
    "msg": [
        "Latn"
    ],
    "msh": [
        "Latn"
    ],
    "msi": [
        "Latn"
    ],
    "msj": [
        "Latn"
    ],
    "msk": [
        "Latn"
    ],
    "msl": [
        "Latn"
    ],
    "msm": [
        "Latn"
    ],
    "msn": [
        "Latn"
    ],
    "mso": [
        "Latn"
    ],
    "msp": [
        "Latn"
    ],
    "msq": [
        "Latn"
    ],
    "msr": [
        "Zxxx"
    ],
    "mss": [
        "Latn"
    ],
    "msu": [
        "Latn"
    ],
    "msv": [
        "Latn"
    ],
    "msw": [
        "Latn"
    ],
    "msx": [
        "Latn"
    ],
    "msy": [
        "Latn"
    ],
    "msz": [
        "Latn"
    ],
    "mt": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "mta": [
        "Latn"
    ],
    "mtb": [
        "Latn"
    ],
    "mtc": [
        "Latn"
    ],
    "mtd": [
        "Latn"
    ],
    "mte": [
        "Latn"
    ],
    "mtf": [
        "Latn"
    ],
    "mtg": [
        "Latn"
    ],
    "mth": [
        "Latn"
    ],
    "mti": [
        "Latn"
    ],
    "mtj": [
        "Latn"
    ],
    "mtk": [
        "Latn"
    ],
    "mtl": [
        "Latn"
    ],
    "mtm": [
        "Cyrl"
    ],
    "mtn": [
        "Latn"
    ],
    "mto": [
        "Latn"
    ],
    "mtp": [
        "Latn"
    ],
    "mtq": [
        "Latn"
    ],
    "mtr": [
        "Deva"
    ],
    "mts": [
        "Latn"
    ],
    "mtt": [
        "Latn"
    ],
    "mtu": [
        "Latn"
    ],
    "mtv": [
        "Latn"
    ],
    "mtw": [
        "Latn"
    ],
    "mtx": [
        "Latn"
    ],
    "mty": [
        "Latn"
    ],
    "mua": [
        "Latn"
    ],
    "mub": [
        "Latn"
    ],
    "muc": [
        "Latn"
    ],
    "mud": [
        "Cyrl"
    ],
    "mue": [
        "Latn"
    ],
    "mug": [
        "Latn"
    ],
    "muh": [
        "Latn"
    ],
    "mui": [
        "Latn"
    ],
    "muj": [
        "Latn"
    ],
    "muk": [
        "Tibt"
    ],
    "mul": [
        "Zyyy"
    ],
    "mum": [
        "Latn"
    ],
    "muo": [
        "Latn"
    ],
    "muq": [
        "Zyyy"
    ],
    "mur": [
        "Latn",
        "Arab"
    ],
    "mus": [
        "Latn"
    ],
    "mut": [
        "Deva"
    ],
    "muu": [
        "Latn"
    ],
    "muv": [
        "Taml"
    ],
    "mux": [
        "Latn"
    ],
    "muy": [
        "Latn"
    ],
    "muz": [
        "Ethi",
        "Latn"
    ],
    "mva": [
        "Latn"
    ],
    "mvb": [
        "Zyyy"
    ],
    "mvd": [
        "Latn"
    ],
    "mve": [
        "Arab"
    ],
    "mvf": [
        "Mong",
        "Phag"
    ],
    "mvg": [
        "Latn"
    ],
    "mvh": [
        "Latn"
    ],
    "mvi": [
        "Zyyy"
    ],
    "mvk": [
        "Latn"
    ],
    "mvl": [
        "Latn"
    ],
    "mvn": [
        "Latn"
    ],
    "mvo": [
        "Latn"
    ],
    "mvp": [
        "Latn"
    ],
    "mvq": [
        "Latn"
    ],
    "mvr": [
        "Latn"
    ],
    "mvs": [
        "Latn"
    ],
    "mvt": [
        "Latn"
    ],
    "mvu": [
        "Latn"
    ],
    "mvv": [
        "Latn"
    ],
    "mvw": [
        "Latn"
    ],
    "mvx": [
        "Latn"
    ],
    "mvy": [
        "Arab"
    ],
    "mvz": [
        "Arab"
    ],
    "mwa": [
        "Latn"
    ],
    "mwb": [
        "Latn"
    ],
    "mwc": [
        "Latn"
    ],
    "mwe": [
        "Latn"
    ],
    "mwf": [
        "Latn"
    ],
    "mwg": [
        "Latn"
    ],
    "mwh": [
        "Latn"
    ],
    "mwi": [
        "Latn"
    ],
    "mwk": [
        "Latn"
    ],
    "mwl": [
        "Latn"
    ],
    "mwm": [
        "Latn"
    ],
    "mwn": [
        "Latn"
    ],
    "mwo": [
        "Latn"
    ],
    "mwp": [
        "Latn"
    ],
    "mwq": [
        "Latn"
    ],
    "mwr": [
        "Deva",
        "Mahj"
    ],
    "mws": [
        "Latn"
    ],
    "mwt": [
        "Mymr",
        "Thai"
    ],
    "mwu": [
        "Latn"
    ],
    "mwv": [
        "Latn"
    ],
    "mww": [
        "Latn",
        "Hmng",
        "Laoo",
        "Plrd",
        "Thai"
    ],
    "mwx": [
        "Latn"
    ],
    "mwy": [
        "Latn"
    ],
    "mwz": [
        "Latn"
    ],
    "mxa": [
        "Latn"
    ],
    "mxb": [
        "Latn"
    ],
    "mxc": [
        "Latn"
    ],
    "mxd": [
        "Latn"
    ],
    "mxe": [
        "Latn"
    ],
    "mxf": [
        "Latn"
    ],
    "mxg": [
        "Latn"
    ],
    "mxh": [
        "Latn"
    ],
    "mxi": [
        "Latn"
    ],
    "mxj": [
        "Latn"
    ],
    "mxk": [
        "Latn"
    ],
    "mxl": [
        "Latn"
    ],
    "mxm": [
        "Latn"
    ],
    "mxn": [
        "Latn"
    ],
    "mxo": [
        "Latn"
    ],
    "mxp": [
        "Latn"
    ],
    "mxq": [
        "Latn"
    ],
    "mxr": [
        "Latn"
    ],
    "mxs": [
        "Latn"
    ],
    "mxt": [
        "Latn"
    ],
    "mxu": [
        "Latn"
    ],
    "mxv": [
        "Latn"
    ],
    "mxw": [
        "Latn"
    ],
    "mxx": [
        "Latn"
    ],
    "mxy": [
        "Latn"
    ],
    "mxz": [
        "Latn"
    ],
    "my": [
        "Mymr",
        "Brai"
    ],
    "myb": [
        "Latn"
    ],
    "myc": [
        "Latn"
    ],
    "mye": [
        "Latn"
    ],
    "myf": [
        "Latn"
    ],
    "myg": [
        "Latn"
    ],
    "myh": [
        "Latn"
    ],
    "myi": [
        "Zyyy"
    ],
    "myj": [
        "Latn"
    ],
    "myk": [
        "Latn"
    ],
    "myl": [
        "Latn"
    ],
    "mym": [
        "Ethi",
        "Latn"
    ],
    "myo": [
        "Zyyy"
    ],
    "myp": [
        "Latn"
    ],
    "myr": [
        "Latn"
    ],
    "mys": [
        "Zyyy"
    ],
    "myu": [
        "Latn"
    ],
    "myv": [
        "Cyrl"
    ],
    "myw": [
        "Latn"
    ],
    "myx": [
        "Latn"
    ],
    "myy": [
        "Latn"
    ],
    "myz": [
        "Mand"
    ],
    "mza": [
        "Latn"
    ],
    "mzb": [
        "Arab",
        "Latn",
        "Tfng"
    ],
    "mzc": [
        "Zxxx"
    ],
    "mzd": [
        "Latn"
    ],
    "mze": [
        "Latn"
    ],
    "mzg": [
        "Zxxx"
    ],
    "mzh": [
        "Latn"
    ],
    "mzi": [
        "Latn"
    ],
    "mzj": [
        "Latn"
    ],
    "mzk": [
        "Latn"
    ],
    "mzl": [
        "Latn"
    ],
    "mzm": [
        "Latn"
    ],
    "mzn": [
        "Arab"
    ],
    "mzo": [
        "Latn"
    ],
    "mzp": [
        "Latn"
    ],
    "mzq": [
        "Latn"
    ],
    "mzr": [
        "Latn"
    ],
    "mzs": [
        "Zyyy"
    ],
    "mzt": [
        "Latn"
    ],
    "mzu": [
        "Latn"
    ],
    "mzv": [
        "Latn"
    ],
    "mzw": [
        "Latn"
    ],
    "mzx": [
        "Latn"
    ],
    "mzy": [
        "Zxxx"
    ],
    "mzz": [
        "Latn"
    ]
};
